export const TILE_LAYER_URL = 'https://korpus.cz/osmtile/mapka/{z}/{x}/{y}.png';
export const TILE_LAYER_CONFIG = {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
};
export const MAP_CONFIG = {
    zoomControl: false, /* Will have custom zoomControl */
    maxZoom: 13,
    minZoom: 8,
    maxBounds: L.latLngBounds(
        [46.809465, 8.820288],
        [52.713416, 22.531445]
    ),
    contextmenu: true,
    zoomDelta: 0.5, /* To change zoom by 0.5 on zoom control */
    zoomSnap: 0.5, /* To change zoom by 0.5 on zoom control */
    wheelPxPerZoomLevel: 120, /* To change zoom by 0.5 on mousewheel */
};
export const INITIAL_VIEW = [49.982541, 15.578613];
export const INITIAL_ZOOM = 8;
export const PANES = [ /* Defines visual order of overlays (z-index) */
    'cr_okresy',
    'cr_kraje',
    'cr_njo',
    'cr_hranice',
    'cr_ceska-zemska-hranice',
    'cr_moravska-zemska-hranice',
];
export const LOCATIONS_WITH_AUDIO = [
    'dialekt_examples',
    'ortofon_examples',
    'oral_examples',
];
